import { createAsyncThunk } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

export const createAttachment = createAsyncThunk(
  "CreateAttachmentSlice/createAttachment",
  async (attachmentData: any, thunkApi) => {
    try {
      let payload: any;
      let config: any = {};

      // Check if this is a file upload (Document type) or link (Link type)
      if (attachmentData.ResourceFileContent) {
        // For Document type - use FormData for multipart upload
        const formData = new FormData();
        formData.append("Action", attachmentData.Action);
        formData.append("ProductId", attachmentData.ProductId);
        formData.append("ResourceType", attachmentData.ResourceType);
        formData.append("Tag", attachmentData.Tag);
        formData.append("ResourceName", attachmentData.ResourceName);
        if (attachmentData.ProductArtifactId) {
          formData.append(
            "ProductArtifactId",
            attachmentData.ProductArtifactId,
          );
        }
        if (attachmentData.ResourceDescription) {
          formData.append("ResourceDescription", attachmentData.ResourceDescription);
        }
        
        formData.append("file", attachmentData.ResourceFileContent);
        
        payload = formData;
        config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
      } else {
        // For Link type - use JSON payload
        payload = {
          Action: attachmentData.Action,
          ProductId: attachmentData.ProductId,
          ResourceType: attachmentData.ResourceType,
          Tag: attachmentData.Tag,
          ResourceName: attachmentData.ResourceName,
          ResourceDescription: attachmentData.ResourceDescription || "",
          ResourceLink: attachmentData.ResourceLink,
          ...(attachmentData.ProductArtifactId
            ? { ProductArtifactId: attachmentData.ProductArtifactId }
            : {}),
        };
        // Content-Type will be set to application/json by interceptor
      }
      
      const response = await httpClient.post(
        "/db/product/artifact/upload",
        payload,
        config
      );
      
      if ((response.status !== 200 && response.status !== 201) || response.data.Status !== "success") {
        return thunkApi.rejectWithValue(response?.data?.Message || "Failed to create artifact");
      }
      return response.data;
    } catch (error: any) {
      const status = error?.response?.status ?? error?.status;
      const errorData = error?.response?.data ?? error?.data;
      const apiMessage = errorData?.message || errorData?.Message;
      return thunkApi.rejectWithValue({
        status,
        message: apiMessage || error?.message || "Failed to create artifact",
      });
    }
  }
);